<template>
  <div class="entrance" v-loading="loading" element-loading-text="加载中,请稍后...">
    <div class="cont">
      <div class="head-cont">
        <img class="head-pic" :src="
            data.cover? data.cover : 'http://ksimg.netban.cn/cover/paper.jpg'
          " alt />
      </div>
      <div class="cont-msg">
        <h3 class="cont-title">
          {{ data.title }}
        </h3>
        <p>试题数量：{{ data.num }}题</p>
        <div v-if="data.type != 4">
          <p>试卷满分：{{ data.score }}分</p>
          <p>答题时间：{{ data.minutes }}分钟</p>
        </div>
        <div style="height:100px" v-if="data.type == 4"></div>
        <div v-if="data.type == 2">
          <p v-if="data.weekly != 0">
            考试开放时间：每周{{ data.weekly }} {{ data.weekly_time }}
          </p>
          <p class="start" v-if="data.weekly == 0">
            考试开放时间：{{ data.start_time }}
          </p>
          <p v-if="data.weekly == 0">考试关闭时间：{{ data.end_time }}</p>
        </div>

        <el-button :disabled="disabled" type="primary" round @click="toPay" v-show="payShow">去支付</el-button>
        <div v-show="!payShow">
          <el-button :disabled="disabled" type="primary" round @click="toAnswer('exam')"
            v-if="!data.is_verify">开始答题</el-button>
          <el-button :disabled="disabled" type="primary" round @click="toAnswer('verify', data.id)"
            v-if="data.is_verify">认证答题</el-button>
        </div>
        <p class="fs_14" style="color: red;" v-if="data.user_points<data.points">*您当前积分为 {{data.user_points}} ，本次考试需要
          {{data.points}} 积分可参加考试！
        </p>
        <p class="text_color fs_14" @click="removeLocal">若您在考试过程中遇到任何异常或报错情况，请点击
          <span style="color: #67C23A;">“此处”</span>
          进行清缓存操作，然后重新开始答题。
        </p>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
      <span>试卷已被关闭,请联系管理员!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="考试须知" :visible.sync="dialogExam" width="800px" center @close="close">
      <div class="examKnow">
        <div v-if="data.knows != 0" v-html="data.knows"></div>
      </div>
      <el-form :model="personalInfo" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="考生姓名：" prop="name">
          <el-input v-model="personalInfo.name" placeholder="请输入考生姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="mobile">
          <el-input v-model="personalInfo.mobile" placeholder="请输入考生手机号码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="diasbled_btn" @click="toVerify('verify', data.id)">{{ countdown }}
            我已知晓并愿意遵守</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogAccount" width="550px" center>
      <p>
        您输入的考生信息与登录的账号信息不一致，请核对一下信息，如机构不一致请重新登录，如账号信息不一致请核实信息并重新输入：
      </p>
      <p><b>账号信息：</b></p>
      <p class="mem_name">
        账号信息：{{ account.mem_name }} {{ account.mem_phone }}
      </p>
      <p>
        <b>您输入的考生信息：</b>
      </p>
      <p class="mem_name">
        考生信息：{{ personalInfo.name }} {{ personalInfo.mobile }}
      </p>
      <span slot="footer" class="dialog-footer">
        <div>
          <el-button type="warning" @click="toLogin" style="margin-right:70px">重新登录</el-button>
          <el-button type="primary" @click="clearInfo">重新输入</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogSubmit" width="400px" center :close-on-click-modal="false"
      :show-close="false">
      <p>
        检测到你有未提交的试卷，请立即提交！
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlePaper">立即提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import $ from "jquery";
  export default {
    name: "entrance",
    data() {
      return {
        data: {},
        personalInfo: {},
        loading: true,
        disabled: false,
        dialogVisible: false,
        is_repeat: 1,
        dialogExam: false,
        countdown: "5",
        timer: null,
        rules: [],
        diasbled_btn: true,
        dialogAccount: false,
        account: {},
        dialogSubmit: false,
        payShow: false,
        weeks: ["0", "一", "二", "三", "四", "五", "六", "七"],
        info: {}
      };
    },
    created() {
      this.toAnswer();
      if (
        this.Storage.getStorage(this.$route.params.id) &&
        this.Storage.getStorage(this.$route.params.id).exam.type == 2
      ) {
        let start_time = this.Storage.getStorage(this.$route.params.id)
          .start_time;
        let exam_time = this.Storage.getStorage(this.$route.params.id).exam_time;
        let time = parseInt(new Date().getTime() / 1000);
        let time_late = exam_time - 20;
        if (time - start_time < exam_time * 60) {
          if (time - start_time > time_late * 60) {
            this.dialogSubmit = true;
          }
        }
      }
    },
    methods: {
      handlePaper() {
        let data = this.Storage.getStorage(this.$route.params.id);
        this.handlePaperData(data);
      },
      handlePaperData(data) {
        let option = [],
          ques = JSON.parse(JSON.stringify(data.ques));
        ques.forEach((item) => {
          option.push({
            id: item.id,
            type: item.type,
            options: item.is_select,
          });

          item.options = JSON.stringify(item.options);
        });
        let exam = JSON.parse(JSON.stringify(this.data));
        exam.usedTime = this.useMinute * 60 + this.useSecond;
        exam.question = JSON.stringify(option);
        let _this = this,
          id = this.$route.params.id;
        this.$http
          .post(process.env.VUE_APP_API_URL + "paper", exam)
          .then(function (data) {
            _this.disabledBtn = false;
            _this.loading = false;
            if (data.data.code == 200) {
              _this.Storage.delStorage(id);
              _this.Storage.delStorage("timer");
              _this.Storage.delStorage("endTimer");
              _this.toAnswer();
              _this.dialogSubmit = false;
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function (error) {
            _this.disabledBtn = false;
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        this.countdown = Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
        this.sendCode();
      },

      sendCode() {
        this.contdown(); //启动定时器
        this.timer = setInterval(() => {
          //创建定时器
          if (this.countdown === 1) {
            this.countdown = "";
            this.clearTimer(); //关闭定时器
            this.diasbled_btn = false;
          } else {
            this.contdown();
          }
        }, 1000);
      },

      contdown() {
        this.countdown--;
      },
      clearTimer() {
        //清除定时器
        clearInterval(this.timer);
        this.timer = null;
      },
      close() {
        this.clearTimer();
      },

      toAnswer(type) {
        let _this = this;
        let id = this.$route.params.id;
        let url;
        if (type) {
          url = "penStart/";
        } else {
          url = "cover/";
        }
        _this.$http
          .get(process.env.VUE_APP_API_URL + url + id)
          .then(function (data) {
            if (data.data.data) {
              let userInfo = {
                idcard: data.data.data.idcard,
                mem_name: data.data.data.mem_name,
              };
              localStorage.setItem("examUserInfo", JSON.stringify(userInfo));
            }
            _this.loading = false;
            if (data.data.code == 200) {
              _this.data = data.data.data;
              _this.data.user_points = data.data.user_points
              if (_this.data.user_points < _this.data.points) {
                _this.disabled = true
              }

              _this.link(type, id);
              if (_this.data.type == 5) {
                _this.data.num = _this.data.fetch_num;
                _this.data.score = _this.data.fetch_num * _this.data.que_score;

              }
              // if (_this.data.type == 5 && !!data.data.son) {
              //   _this.data.num = data.data.son.num;
              //   _this.data.score = data.data.son.score;
              // }
              _this.data.weekly = _this.weeks[_this.data.weekly];
              if (_this.data.is_pay == 0 && _this.data.pay > 0) {
                _this.payShow = true;
              }
              _this.is_repeat = data.data.data.is_repeat;
              return false
            }
            if (data.data.code == 402) {
              if (data.data.data) {
                let url = window.location.href;
                if (url.indexOf("netclass") != -1) {
                  window.location.href =
                    "http://netclass.cn/login?url=" + btoa(url);
                } else {
                  window.location.href =
                    "http://custom.netban.cn/app/login.html?id=" +
                    data.data.data +
                    "&url=" +
                    btoa(url);
                }
              } else {
                _this.$message.warning("权限不足，不能答题！");
              }
              return false
            }

            if (data.data.code == 500) {
              _this.dialogVisible = true;
              return false
            }

            // _this.data = data.data.data;
            // _this.data.weekly = _this.weeks[_this.data.weekly];
            _this.disabled = true;
            _this.$message.error(data.data.msg);
          })
          .catch(function (error) {
            _this.loading = false;
            // _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      link(name, id) {
        if (this.data.notice == 1) {
          this.getRandomIntInclusive(5, 10);
          this.dialogExam = true;
          this.diasbled_btn = true;
        } else {
          let params = {
            id: id,
            is_repeat: this.is_repeat,
          };
          this.$router.push({ name, params: { id, is_repeat: this.is_repeat } });
        }
      },
      toVerify(name, id) {
        let _this = this;
        if (!_this.personalInfo.name) {
          _this.$message.error("请输入考生姓名");
          return;
        }
        if (!_this.personalInfo.mobile) {
          _this.$message.error("请输入考生手机号码");
          return;
        }
        _this.personalInfo.id = id;
        _this.$http
          .post(
            process.env.VUE_APP_API_URL + "verification_user",
            _this.personalInfo
          )
          .then(function (data) {
            _this.loading = false;
            if (data.data.code == 500) {
              _this.dialogExam = false;
              setTimeout(() => {
                _this.dialogAccount = true;
              }, 500);
              _this.account = data.data.auth;
              _this.account.mem_phone = _this.account.mem_phone.replace(
                /(\d{3})\d{4}(\d{4})/,
                "$1****$2"
              );
            }
            if (data.data.code == 200) {
              _this.$router.push({
                name,
                params: { id, is_repeat: _this.is_repeat },
              });
            }
            if (data.data.code == 404) {
              _this.dialogExam = false;
              setTimeout(() => {
                _this.dialogAccount = true;
              }, 500);
              _this.account = data.data.data;
              _this.account.mem_phone = _this.account.mem_phone.replace(
                /(\d{3})\d{4}(\d{4})/,
                "$1****$2"
              );
            }
          })
          .catch(function (error) {
            _this.loading = false;
            // _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      clearInfo() {
        this.dialogAccount = false;
        this.personalInfo = {};
      },
      toLogin() {
        let jid = this.getCookie("jid");
        // window.open('http://custom.netban.cn/app/login.html')
        let url = window.location.href;
        if (url.indexOf("netclass") != -1) {
          window.location.href = "http://netclass.cn/login?url=" + btoa(url);
        } else {
          window.location.href =
            "http://custom.netban.cn/app/login.html?id=" +
            jid +
            "&url=" +
            btoa(url);
        }
      },
      toPay() {
        let _this = this;
        let subsystem_url = window.location.href;
        _this.$http
          .post(process.env.VUE_APP_API_URL + "pay", {
            paper_id: this.$route.params.id,
            subsystem_url: subsystem_url,
          })
          .then((data) => {
            if (data.data.code == 200) {
              //未付款
              _this.order_number = data.data.data;
              window.location.href =
                "http://pay.netban.cn/pay/" + this.order_number; //跳转至支付页面
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch((err) => {
            _this.$message.error("网络错误，请重试");
            console.log(err);
          });
      },
      removeLocal() {
        localStorage.removeItem(this.$route.params.id);
        this.$message.success("清除成功");
      },
    },
  };
</script>
<style lang="less" scope>
  .entrance {
    background: url("../assets/result-bg.jpg") no-repeat;
    background-size: cover;
    max-width: 1000px;
    margin: 0 auto;

    .cont {
      border-radius: 5px;
      padding: 30px 20px 40px 20px;

      .head-cont {

        // height: 230px;
        .head-pic {
          width: 100%;
          // height: 100%;
        }
      }

      .cont-msg {
        background-color: #fff;
        text-align: center;
        font-size: 16px;
        color: #3a3a3a;
        padding: 25px 0;

        .cont-title {
          font-size: 22px;
          margin: 0;
          color: #000;
        }

        p {
          margin: 0;
          padding: 14px 0;
        }

        .start {
          padding-bottom: 0;
        }
      }
    }

    .examKnow {
      font-size: 16px;
      margin-bottom: 30px;
      padding-left: 7px;
      line-height: 25px;
    }

    .el-input {
      width: 250px;
    }

    .el-form {
      padding-left: 170px;
    }
  }

  .el-button+.el-button {
    margin-left: 80px;
  }

  .mem_name {
    padding-left: 30px;
  }

  .text_color {
    color: #666;
  }

  .fs_14 {
    font-size: 14px;
  }
</style>